import { useAppDispatch } from "../../../store/hooks/StoreHooks";
import {
    setProtectorSeries,
    fetchOilContraction,
    fetchProtectorCalculations,
    fetchProtectorPercentage,
    fetchSelectedProtector,
    fetchEquipments,
    setSelectedLowerProtector,
    setSelectedLowerEquipment,
    setSelectedUpperEquipment,
    fetchSelectedLowerProtector,
    fetchSelectedUpperProtector,
    setSelectedUpperProtector,
    setShaftRatingValue,
    setShaftPercentage,
} from "../../../../src/store/calculation/calculation-output/protectorSlice";
import { setHiddenProtector1, setHiddenProtector2, setHiddenProtectorBearingType, setHiddenProtectorOilType, setHiddenProtectorShaftType } from "../../../store/calculation/calculation-input/TubingSlice";
import { setSurfaceCalculationComplete } from "../../../store/calculation/calculation-output/surfaceEquipmentSlice";


const useProtectorFacade = () => {
    const dispatch = useAppDispatch();

    const updateProtectorSeries = (payload: string) => {
        return dispatch(setProtectorSeries(payload));
    };

    const updateSelectedOilType = (payload: string) => {
        return dispatch(setHiddenProtectorOilType(payload));
    };

    const loadOilContraction = (payload: any) => {
        return dispatch(fetchOilContraction(payload));
    };

    const loadProtectorCalculations = async (value: string, name: any) => {
        if (name === "bearingType") {
            dispatch(setSurfaceCalculationComplete(false));
            dispatch(setHiddenProtectorBearingType(value));
        } else if (name === "shaftType") {
            dispatch(setHiddenProtectorShaftType(value));
        }
        loadProtectorCalculation();
    }

    const loadProtectorCalculation = () => {
        dispatch(fetchProtectorCalculations());
    }

    const generatePercentageLoadCheck = () => {
        return dispatch(fetchProtectorPercentage());
    }

    const loadSelectedProtector = (payload: any) => {
        return dispatch(fetchSelectedProtector(payload));
    }

    const loadEquipments = async () => {
        return dispatch(fetchEquipments());
    }

    const resetLowerProtector = () => {
        dispatch(setSurfaceCalculationComplete(false));
        dispatch(setSelectedLowerProtector({}));
        dispatch(setHiddenProtector1(""));
        dispatch(setShaftRatingValue(0));
        dispatch(setShaftPercentage(0));
    }
    const resetUpperProtector = () => {
        return dispatch(setSelectedUpperProtector({}) && setHiddenProtector2(""));
    }

    const updateSelectedLowerEquipment = (payload: any) => {
        return dispatch(setSelectedLowerEquipment(payload));
    }

    const updateSelectedUpperEquipment = (payload: any) => {
        return dispatch(setSelectedUpperEquipment(payload));
    }

    const loadSelectedLowerProtector = () => {
        return dispatch(fetchSelectedLowerProtector());
    }

    const loadSelectedUpperProtector = () => {
        return dispatch(fetchSelectedUpperProtector());
    }

    const updateShaftRatingValue = (value: number) => {
        dispatch(setShaftRatingValue(value));
        dispatch(setShaftPercentage(value));
    }

    return {
        updateProtectorSeries,
        updateSelectedOilType,
        loadOilContraction,
        loadProtectorCalculations,
        generatePercentageLoadCheck,
        loadSelectedProtector,
        loadEquipments,
        resetLowerProtector,
        resetUpperProtector,
        updateSelectedLowerEquipment,
        updateSelectedUpperEquipment,
        loadSelectedLowerProtector,
        loadSelectedUpperProtector,
        loadProtectorCalculation,
        updateShaftRatingValue
    };
}


export default useProtectorFacade;
